import i from './deposit-history.container';

export default i;
